export const PROPERTY_SECTION_KEYS = [
  'identity',
  'address',
  'registry',
  'laudemio',
  'values',
  'deadline',
  'clauses',
  'documents',
];

export const propertySections = t => [
  {
    key: 'identity',
    label: t('SALES_PROPERTY.SECTIONS.IDENTITY'),
    icon: 'i-lucide-hash',
  },
  {
    key: 'address',
    label: t('SALES_PROPERTY.SECTIONS.ADDRESS'),
    icon: 'i-lucide-map-pin',
  },
  {
    key: 'registry',
    label: t('SALES_PROPERTY.SECTIONS.REGISTRY'),
    icon: 'i-lucide-landmark',
  },
  {
    key: 'laudemio',
    label: t('SALES_PROPERTY.SECTIONS.LAUDEMIO'),
    icon: 'i-lucide-waves',
  },
  {
    key: 'values',
    label: t('SALES_PROPERTY.SECTIONS.VALUES'),
    icon: 'i-lucide-circle-dollar-sign',
  },
  {
    key: 'deadline',
    label: t('SALES_PROPERTY.SECTIONS.DEADLINE'),
    icon: 'i-lucide-calendar-clock',
  },
  {
    key: 'clauses',
    label: t('SALES_PROPERTY.SECTIONS.CLAUSES'),
    icon: 'i-lucide-file-pen-line',
  },
  {
    key: 'documents',
    label: t('SALES_PROPERTY.SECTIONS.DOCUMENTS'),
    icon: 'i-lucide-files',
  },
];

export const laudemioTypes = t => [
  { value: '1', label: t('SALES_PROPERTY.OPTIONS.LAUDEMIO.UNION') },
  { value: '2', label: t('SALES_PROPERTY.OPTIONS.LAUDEMIO.CITY') },
  { value: '3', label: t('SALES_PROPERTY.OPTIONS.LAUDEMIO.FAMILY') },
  { value: '4', label: t('SALES_PROPERTY.OPTIONS.LAUDEMIO.CHURCH') },
];

export const paymentOptions = t => [
  { value: '1', label: t('SALES_PROPERTY.OPTIONS.PAYMENT.CASH') },
  { value: '2', label: t('SALES_PROPERTY.OPTIONS.PAYMENT.FINANCING') },
  { value: '3', label: t('SALES_PROPERTY.OPTIONS.PAYMENT.FGTS') },
  { value: '4', label: t('SALES_PROPERTY.OPTIONS.PAYMENT.CONSORTIUM') },
  { value: '5', label: t('SALES_PROPERTY.OPTIONS.PAYMENT.INSTALLMENTS') },
];

export const daysOptions = t => [
  { value: '1', label: t('SALES_PROPERTY.OPTIONS.DAYS.BUSINESS') },
  { value: '2', label: t('SALES_PROPERTY.OPTIONS.DAYS.CALENDAR') },
];
